export default __webpack_public_path__ + "static/media/img (1).2cd347f1.jpg";